import Api from '.';

/**
 * 
 * Retrieve all clients.
 */
export function getClients() {
    return Api.get('/client');
}

/**
 * 
 * Create client.
 */
export function createClient(client) {
    return Api.post('/client', { client });
}

/**
 * 
 * Update client.
 */
export function updateClient(id, client) {
    return Api.put(`/client/${id}`, { client });
}

/**
 * 
 * Update client status.
 */
export function updateClientStatus(id, status) {
    return Api.put(`/client/${id}/status`, { status });
}

/**
 * 
 * Delete client.
 */
export function deleteClient(id) {
    return Api.delete(`/client/${id}`);
}
